


















import { Component, Vue, Prop } from 'vue-property-decorator';
import Modal from '@/main-components/common/modal/Modal.vue';
import MainButton from '@/main-components/common/MainButton.vue';
import CoursePurchasedContent from '@/components/course/CoursePurchasedContent.vue';
import { CourseItem } from '@/resource/course-item/course-item.model';

@Component({
  components: {
    Modal,
    MainButton,
    CoursePurchasedContent,
  },
})
export default class ModalCourseContent extends Vue {
  @Prop({ required: true })
  courseItems: CourseItem[];

  @Prop({ required: true })
  courseProgress: number;

  openModal: any = null;
  closeModal: any = null;

  mounted() {
    this.$emit('openModalCourseContent', this.openModal);
    this.$emit('closeModalCourseContent', this.closeModal);
  }

  openModalAdd(openModal: any) {
    this.openModal = openModal;
  }

  closeModalAdd(closeModal: any) {
    this.closeModal = closeModal;
  }
}
